module.exports = __webpack_public_path__ + "img/IconStart.7c8e771f.png";